module.exports = require("lodash/omit");